import { render, staticRenderFns } from "./ReportPages.vue?vue&type=template&id=4cb63cd7&"
import script from "./ReportPages.vue?vue&type=script&lang=js&"
export * from "./ReportPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports